var ezdia;
(function (ezdia) {
    var TYPE = 'CREATE_USER';
    var FRM_NAME = 'createUserForm';
    var pageParams = {};
    var frm = null;
    var saveData = function () {
        var data = frm.serialize();
        $.ajax({
            type: 'POST',
            url: 'CreateAUser.htm',
            data: data,
            dataType: 'json',
            success: function (response) {
                var url = '';
                var email = $('#email').val();
                if (response) {
                    url =
                        response.url ||
                            pageParams.CONTEXT_ROOT + "/desk/MyTask.htm?accountName=expert&userManagement=true&email=" + email;
                }
                var obj = {
                    response: response.msg,
                    success: response.success,
                    url: url
                };
                successErrorDialog(obj);
            },
            error: function (response) {
                var obj = {
                    response: response.statusText,
                    success: false,
                    url: ''
                };
                successErrorDialog(obj);
            }
        });
    };
    var validate = function () {
        $.ezdia.validate.all(pageParams.colModel, 'createUserForm');
    };
    var submit = function () {
        $('#submitcreateuser').on('click', function click() {
            if (!frm.valid()) {
                return;
            }
            saveData();
        });
    };
    var generatePassword = function () {
        var checkbox = $('#generatePassword');
        var password = $('#password');
        var confirmpassword = $('#confirmpassword');
        var sendEmail = $('#sendEmail');
        var sendEmailName = sendEmail.attr('name');
        var passwordRow = password.closest('[data-row="row"]');
        var confirmpasswordRow = confirmpassword.closest('[data-row="row"]');
        if (!checkbox.val()) {
            checkbox.val('true');
        }
        if (!sendEmail.val()) {
            sendEmail.val('true');
        }
        checkbox.on('click', function click() {
            var disable = $(this).is(':checked');
            confirmpassword.attr('disabled', disable).val('');
            password.attr('disabled', disable).val('');
            sendEmail.prop('checked', 'checked').attr('disabled', disable);
            if (disable) {
                $.ezdia.validate.unhighlight(frm, password);
                $.ezdia.validate.unhighlight(frm, confirmpassword);
                passwordRow.hide();
                confirmpasswordRow.hide();
                sendEmail
                    .removeAttr('name')
                    .after("<input type=\"hidden\" name=\"" + sendEmailName + "\" value=\"true\">");
            }
            else {
                passwordRow.show();
                confirmpasswordRow.show();
                sendEmail
                    .attr('name', sendEmailName)
                    .next('input[type="hidden"]')
                    .remove();
            }
        });
    };
    var pages;
    (function (pages) {
        pages.createUser = {
            onload: function () {
                pageParams = $.ezdia.config.pageParams;
                frm = $("#" + FRM_NAME);
                validate();
                generatePassword();
                $.ezdia.widgets.renderAll(pageParams.colModel, TYPE);
                submit();
                pageLoadingDone();
            }
        };
    })(pages = ezdia.pages || (ezdia.pages = {}));
})(ezdia || (ezdia = {}));
